import React, { memo } from 'react';
import { Instagram, Facebook, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-cream-100 pt-20 pb-10 border-t border-white/10" data-id="element-93">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-95">
          {/* Column 1: Brand */}
          <div className="lg:col-span-1" data-id="element-96">
            <a href="#" className="inline-block mb-6" data-id="element-97">
              <span className="font-playfair text-2xl font-bold tracking-tight text-white" data-id="element-98">
                Wine & Design
              </span>
            </a>
            <p className="text-cream-100/70 text-sm leading-relaxed mb-6 max-w-xs" data-id="element-99">
              Curated wines and custom label services that make every experience
              personal, accessible, and memorable.
            </p>
            <div className="flex space-x-4" data-id="element-100">
              <a href="#" className="text-cream-100/50 hover:text-gold transition-colors" data-id="element-101">
                <span className="sr-only" data-id="element-102">Instagram</span>
                <Instagram className="h-5 w-5" data-id="element-103" />
              </a>
              <a href="#" className="text-cream-100/50 hover:text-gold transition-colors" data-id="element-104">
                <span className="sr-only" data-id="element-105">Facebook</span>
                <Facebook className="h-5 w-5" data-id="element-106" />
              </a>
              <a href="#" className="text-cream-100/50 hover:text-gold transition-colors" data-id="element-107">
                <span className="sr-only" data-id="element-108">Twitter</span>
                <Twitter className="h-5 w-5" data-id="element-109" />
              </a>
            </div>
          </div>

          {/* Column 2: Explore */}
          <div data-id="element-110">
            <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-6" data-id="element-111">
              Explore
            </h3>
            <ul className="space-y-4" data-id="element-112">
              <li data-id="element-113">
                <a href="#collection" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-114">
                  Our Wines
                </a>
              </li>
              <li data-id="element-115">
                <a href="/design#gallery" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-116">
                  Custom Labels
                </a>
              </li>
              <li data-id="element-117">
                <a href="/design" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-118">
                  How It Works
                </a>
              </li>
              <li data-id="element-119">
                <a href="#pricing" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-120">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Company */}
          <div data-id="element-121">
            <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-6" data-id="element-122">
              Company
            </h3>
            <ul className="space-y-4" data-id="element-123">
              <li data-id="element-124">
                <a href="#about" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-125">
                  About Us
                </a>
              </li>
              <li data-id="element-126">
                <a href="#" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-127">
                  Our Vineyard
                </a>
              </li>
              <li data-id="element-128">
                <a href="#" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-129">
                  Partners
                </a>
              </li>
              <li data-id="element-130">
                <a href="#" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-131">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Support */}
          <div data-id="element-132">
            <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-6" data-id="element-133">
              Support
            </h3>
            <ul className="space-y-4" data-id="element-134">
              <li data-id="element-135">
                <a href="#" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-136">
                  Contact
                </a>
              </li>
              <li data-id="element-137">
                <a href="#" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-138">
                  FAQ
                </a>
              </li>
              <li data-id="element-139">
                <a href="#" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-140">
                  Shipping
                </a>
              </li>
              <li data-id="element-141">
                <a href="#" className="text-cream-100/70 hover:text-white text-sm transition-colors" data-id="element-142">
                  Terms
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-143">
          <p className="text-cream-100/50 text-xs" data-id="element-144">
            &copy; {new Date().getFullYear()} Wine & Design. All rights
            reserved.
          </p>
          <div className="flex space-x-6" data-id="element-145">
            <a href="#" className="text-cream-100/50 hover:text-white text-xs transition-colors" data-id="element-146">
              Privacy Policy
            </a>
            <a href="#" className="text-cream-100/50 hover:text-white text-xs transition-colors" data-id="element-147">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}